"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@commerce-ui/core2");
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _excluded = ["sx", "inputRef", "onChange", "onEnter"];
var __jsx = _react["default"].createElement;
/**
 * Input Raw
 */
var inputResetStyles = {
  border: 0,
  bg: "transparent",
  ":invalid": {
    boxShadow: "none",
    outline: "none"
  },
  "::-webkit-outer-spin-button, ::-webkit-inner-spin-button, ::-webkit-search-decoration, ::-webkit-search-cancel-button, ::-webkit-search-results-button, ::-webkit-search-results-decoration": {
    WebkitAppearance: "none"
  },
  WebkitAppearance: "none",
  MozAppearance: "textfield"
};
var InputRaw_ = function InputRaw_(props) {
  var sx = props.sx,
    inputRef = props.inputRef,
    _onChange = props.onChange,
    onEnter = props.onEnter,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _splitSx = (0, _core.splitSx)(sx),
    _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 1),
    css = _splitSx2[0];
  return __jsx(_Box["default"], (0, _extends2["default"])({
    as: "input",
    sx: [inputResetStyles, css],
    onChange: function onChange(event) {
      if (_onChange) {
        _onChange(event.target.value, event);
      }
    },
    onKeyDown: function onKeyDown(event) {
      if (!onEnter) return;
      if (event.key === "Enter") {
        onEnter();
      }
    }
  }, restProps, {
    ref: inputRef
  }));
};
var InputRaw = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return __jsx(InputRaw_, (0, _extends2["default"])({
    inputRef: ref
  }, props));
});
var _default = InputRaw;
exports["default"] = _default;